<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar style="position:relative;z-index:100" dense flat light color="white">
          <v-toolbar-title>
            <img
              style="margin-top:10px"
              src="https://static.paymentiq.io/worldline-logo.svg"
              width="130px"
              alt="Bambora logo">
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn class="white mr-5" depressed @click="showCodeSnippet = !showCodeSnippet">
              Show code
              <v-icon class="ml-2">mdi-code-array</v-icon>
            </v-btn>
            <v-btn class="white" depressed @click="closeDialog">
              Close
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider></v-divider>

        <Carousel
          :reloadCashierCarousel="reloadCashierCarousel"
        />

      </v-card>
    </v-dialog>

    <v-dialog v-model="showCodeSnippet" max-width="900">
      <div class="pt-5 white show-code-container">
        <CodeSnippets />
      </div>
    </v-dialog>
  </v-row>
</template>

<script>
import Carousel from './Carousel'
import CodeSnippets from '@/components/CodeSnippets'

export default {
  name: 'Showcase-modal',
  components: {
    Carousel,
    CodeSnippets
  },
  props: {
    dialog: { type: Boolean, required: true },
    closeDialog: { type: Function, required: true },
    reloadCashierCarousel: { type: Number, required: true }
  },
  data: () => ({
    showCodeSnippet: false
  }),
  beforeDestroy () {
    this.showCodeSnippet = false
  }
}
</script>

<style lang="scss" scoped>
.show-code-container {
  position: relative;
  display: flex;
  justify-content: center;
}
</style>
